// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import wineGlassIcon from "@/assets/icons/aop/wine-glass.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type WineGlassIconProps = Omit<IconProps, "name">;

export function WineGlassIcon(props: WineGlassIconProps): React.ReactNode {
  return <Icon name={wineGlassIcon} {...props} />;
}
